import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import type { OddsModel, SportMatchModel } from '@nf/types/odds';
import type { Category } from '@/types/category-setting';

export const isOddsPageLoadingAtom = atom(true);

export const isMatchOddsPageLoadingAtom = atom(true);

export const oddsPageAtom = atom<OddsModel | null>(null);

export const oddsModelLeaguesAtom = atom(get => {
	const oddsModel = get(oddsPageAtom);
	return oddsModel?.leagueNameMap ?? new Map<number, string>();
});

export const matchOddsPageAtom = atom<SportMatchModel | null>(null);

export const pageSideMatchIdAtom = atom(0);

export const sideMatchAtom = atom(get => {
	const matches = get(oddsPageAtom)?.MatchCollection ?? [];
	return matches.find(match => match.MatchId === get(pageSideMatchIdAtom));
});

export const earlyFilterDateAtom = atom<string>('');

export const currentSingleMatchCategoryAtom = atom<Category | null>(null);

export const hasFilteredMatchesAtom = atomWithReset<boolean | undefined>(undefined);